(function() { window.GUID_7cf5c156_7ec2_48e5_92bf_bc7dba0f77a4 = { getGuid: function() { return "7cf5c156-7ec2-48e5-92bf-bc7dba0f77a4"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class OTPInput extends Controls.ControlValueBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.digitCount = params[1] || 6;
                this.autoFocus = params[2] !== false;
                this.numericOnly = params[3] !== false;
                this.$control = $('#' + this.controlId);
                this.$hiddenInput = this.$control.find('#' + this.controlId + '-child');
                this.$digitInputs = this.$control.find('.otp-digit-input');
                // Initialize with existing value if present
                const existingValue = this.$hiddenInput.val();
                if (existingValue) {
                    this.SetValue(existingValue);
                }
                // Auto-focus first input if enabled
                if (this.autoFocus) {
                    this.$digitInputs.first().focus();
                }
            }
            OnDispose() {
                this.$digitInputs.off('.' + this.UniqueNamespace);
                this.$control.remove();
            }
            OnBindEvents() {
                const me = this;
                // Handle input on each digit box
                this.$digitInputs.each(function (index) {
                    const $input = $(this);
                    // Input event - validate and move to next
                    $input.offon('input.' + me.UniqueNamespace, function (e) {
                        let value = $input.val().toUpperCase();
                        // Validate numeric only if enabled
                        if (me.numericOnly && value && !/^\d$/.test(value)) {
                            $input.val('');
                            return;
                        }
                        // Convert to uppercase and limit to 1 character
                        if (value.length > 1) {
                            value = value.charAt(0);
                        }
                        $input.val(value);
                        // Update hidden input with combined value
                        me.UpdateHiddenInput();
                        // Move to next input if value entered
                        if (value && index < me.digitCount - 1) {
                            me.$digitInputs.eq(index + 1).focus();
                        }
                        // Trigger value changed event
                        me.Trigger(OTPInput.EventNames.ValueChanged, {
                            jqueryEventObject: e,
                            data: me.GetValue()
                        });
                    });
                    // Keydown event - handle backspace and navigation
                    $input.offon('keydown.' + me.UniqueNamespace, function (e) {
                        const key = CS.GetKeyPressed(e);
                        // Backspace - move to previous input if current is empty
                        if (e.keyCode == 8) { // Backspace key code
                            const currentValue = $input.val();
                            if (!currentValue && index > 0) {
                                me.$digitInputs.eq(index - 1).focus().select();
                            }
                        }
                        // Left arrow - move to previous input
                        if (key == CS.Enums.KeyCode.ArrowLeft && index > 0) {
                            e.preventDefault();
                            me.$digitInputs.eq(index - 1).focus().select();
                        }
                        // Right arrow - move to next input
                        if (key == CS.Enums.KeyCode.ArrowRight && index < me.digitCount - 1) {
                            e.preventDefault();
                            me.$digitInputs.eq(index + 1).focus().select();
                        }
                        // Enter key - trigger complete event
                        if (key == CS.Enums.KeyCode.Enter) {
                            me.Trigger(OTPInput.EventNames.EnterKeyPressed, {
                                jqueryEventObject: e,
                                data: me.GetValue()
                            });
                        }
                    });
                    // Paste event - split pasted value across inputs
                    $input.offon('paste.' + me.UniqueNamespace, function (e) {
                        var _a;
                        e.preventDefault();
                        const pastedData = ((_a = e.originalEvent.clipboardData) === null || _a === void 0 ? void 0 : _a.getData('text')) || '';
                        me.HandlePaste(pastedData, index);
                    });
                    // Focus event - select all text
                    $input.offon('focus.' + me.UniqueNamespace, function () {
                        $input.select();
                    });
                });
            }
            HandlePaste(pastedValue, startIndex) {
                // Clean the pasted value
                let cleanedValue = pastedValue.toUpperCase().replace(/\s/g, '');
                // If numeric only, remove non-numeric characters
                if (this.numericOnly) {
                    cleanedValue = cleanedValue.replace(/\D/g, '');
                }
                // Distribute characters across inputs starting from current index
                for (let i = 0; i < cleanedValue.length && (startIndex + i) < this.digitCount; i++) {
                    this.$digitInputs.eq(startIndex + i).val(cleanedValue.charAt(i));
                }
                // Update hidden input
                this.UpdateHiddenInput();
                // Focus next empty input or last input
                const nextEmptyIndex = this.FindNextEmptyInput(startIndex);
                if (nextEmptyIndex !== -1) {
                    this.$digitInputs.eq(nextEmptyIndex).focus();
                }
                else {
                    this.$digitInputs.eq(this.digitCount - 1).focus();
                }
                // Trigger value changed event
                this.Trigger(OTPInput.EventNames.ValueChanged, {
                    jqueryEventObject: null,
                    data: this.GetValue()
                });
            }
            FindNextEmptyInput(startIndex) {
                for (let i = startIndex; i < this.digitCount; i++) {
                    if (!this.$digitInputs.eq(i).val()) {
                        return i;
                    }
                }
                return -1;
            }
            UpdateHiddenInput() {
                const combinedValue = this.GetValue();
                this.$hiddenInput.val(combinedValue);
            }
            GetValue() {
                let value = '';
                this.$digitInputs.each(function () {
                    value += $(this).val() || '';
                });
                return value;
            }
            SetValue(value, triggerValueChangedEvent) {
                const cleanedValue = (value || '').toUpperCase();
                // Clear all inputs first
                this.$digitInputs.val('');
                // Set each digit
                for (let i = 0; i < Math.min(cleanedValue.length, this.digitCount); i++) {
                    this.$digitInputs.eq(i).val(cleanedValue.charAt(i));
                }
                // Update hidden input
                this.UpdateHiddenInput();
                if (triggerValueChangedEvent) {
                    this.Trigger(OTPInput.EventNames.ValueChanged, {
                        jqueryEventObject: null,
                        data: this.GetValue()
                    });
                }
            }
            Clear() {
                this.$digitInputs.val('');
                this.$hiddenInput.val('');
                this.$digitInputs.first().focus();
            }
            IsFilled() {
                return this.GetValue().length === this.digitCount;
            }
        }
        Controls.OTPInput = OTPInput;
        (function (OTPInput) {
            class Events extends Controls.ControlValueBase.Events {
                static ValueChanged(param) {
                    Controls.RegisterEvent(OTPInput, EventNames.ValueChanged, param);
                }
                static EnterKeyPressed(param) {
                    Controls.RegisterEvent(OTPInput, EventNames.EnterKeyPressed, param);
                }
            }
            OTPInput.Events = Events;
            class EventNames extends Controls.ControlValueBase.EventNames {
            }
            EventNames.ValueChanged = "otpinput-valuechanged";
            EventNames.EnterKeyPressed = "otpinput-enterkeypressed";
            OTPInput.EventNames = EventNames;
        })(OTPInput = Controls.OTPInput || (Controls.OTPInput = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=OTPInput.js.map
